import { Injectable } from '@angular/core';
import { Apollo, Mutation } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { gql } from 'apollo-angular';
import { Exact } from 'src/generated/graphql';

export type UpdateAwardCriteriaMutationVariables = Exact<{
  id: number;
  data: {
    individual?: number;
    team?: number;
    numberOfPoints?: number;
  };
}>;

export type UpdateAwardCriteriaMutation = {
  updateAwardCriteria: {
    id: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class UpdateAwardCriteriaGQL extends Mutation<
  UpdateAwardCriteriaMutation,
  UpdateAwardCriteriaMutationVariables
> {
  document = gql`
    mutation UpdateAwardCriteria($id: Float!, $data: UpdateAwardCriteriaDto!) {
      updateAwardCriteria(id: $id, data: $data) {
        id
      }
    }
  `;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
